import React from 'react';
import {BrowserRouter as Router, Route, Routes, Navigate, Outlet} from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './Css/Global/Global.css';

import { CustomThemeProvider } from './ThemeContext';
import TooltipFixProvider from './Components/TooltipFixProvider';

import PrivateRoute from "./Components/PrivateRoute";
import 'dayjs/locale/pt-br';
import MainLayout from "./Components/MainLayout";
import Login from "./Pages/Login";

import Dashboard from './Pages/Dashboard';
import Analises from './Pages/Analises';
import AnalisesProduto from './Pages/AnalisesProduto';
import AnalisesNcm from './Pages/AnalisesNcm';

import AccessProfile from './Pages/AccessProfile';
import Users from './Pages/Users';
import Sped from './Pages/Sped';
import EstruturaMercadologica from './Pages/EstruturaMercadologica';
import Ncm from './Pages/Ncm';
import Ean from './Pages/Ean';
import Products from './Pages/Products';
import NFEs from './Pages/NFEs';
import ServerError from "./Pages/ServerError";
import NotFound from "./Pages/NotFound";
import {GlobalProvider} from "./Providers/GlobalProvider";
import {ProductProvider} from "./Providers/ProductProvider";
import AnalisesEstruturaMercadologica from './Pages/AnalisesEstruturaMercadologica';
import AnalisesPerdas from './Pages/AnalisesPerdas';
import DivergenciasPage from './Pages/Divergencias';
import AnalisesCompras from './Pages/AnalisesCompras';
import AnalisesVendas from './Pages/AnalisesVendas';
import AnalisesResultadoBruto from './Pages/AnalisesResultadoBruto';
import AnalisesDrf from './Pages/AnalisesDrf';
import Establishments from './Pages/Establishments';

const App: React.FC = () => {
    return (
        <Router>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='pt-br'>
                <Routes>
                                            <Route
                            path="/"
                            element={
                                <CustomThemeProvider>
                                    <TooltipFixProvider>
                                        <GlobalProvider>
                                            <ProductProvider>
                                                <MainLayout>
                                                    <PrivateRoute/>
                                                </MainLayout>
                                            </ProductProvider>
                                        </GlobalProvider>
                                    </TooltipFixProvider>
                                </CustomThemeProvider>
                            }
                    >
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/usuarios" element={<Users />} />
                        <Route path="/accessprofiles/:parametro1?/:parametro2?" element={<AccessProfile />} />
                        <Route path="/sped" element={<Sped />} />
                        <Route path="/produtos" element={<Products />} />
                        <Route path="/nfes" element={<NFEs />} />
                        <Route path="/estruturaMercadologica" element={<EstruturaMercadologica />} />
                        <Route path="/ncm" element={<Ncm />} />
                        <Route path="/ean" element={<Ean />} />
                        <Route path="/analises" element={<Analises />} />
                        <Route path="/analisesProduto" element={<AnalisesProduto />} />
                        <Route path="/analisesEstruturaMercadologica" element={<AnalisesEstruturaMercadologica />} />
                        <Route path="/analisesNcm" element={<AnalisesNcm />} />
                        <Route path="/analisesPerdas" element={<AnalisesPerdas />} />
                        <Route path="/divergencias" element={<DivergenciasPage />} />
                        <Route path="/analisesCompras" element={<AnalisesCompras />} />
                        <Route path="/analisesVendas" element={<AnalisesVendas />} />
                        <Route path="/analisesResultadoBruto" element={<AnalisesResultadoBruto />} />
                        <Route path="/analisesDrf" element={<AnalisesDrf />} />
                        <Route path="/estabelecimentos" element={<Establishments />} />
                    </Route>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/404" element={<NotFound/>}/>
                    <Route path="/500" element={<ServerError/>}/>
                    <Route path="*" element={<Navigate to="/404"/>}/>
                </Routes>
            </LocalizationProvider>
        </Router>
    );
}

export default App;
